

import { mapActions, mapGetters, mapMutations } from 'vuex'
import redirectWeb from '../mixins/redirectWeb'
import alertWeb from '../mixins/alertWeb'
import logistics from '../mixins/logistics'
import reorder from '../mixins/reorder'
import orderHistory from '../mixins/orderHistory'
import ModalShowReceipt from './modals/ModalShowReceipt'

export default {
  name: 'Orders',
  components: {
    ModalShowReceipt
  },
  mixins: [redirectWeb, alertWeb, logistics, reorder, orderHistory],
  data () {
    return {
      currentPage: 1,
      perPage: 2
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'orderHistory']),
    rows () {
      if (this.orderHistory.meta) {
        return this.orderHistory.meta.total
      }
      return 0
    }
  },
  created () {
    const data = {
      type: 'customer',
      customer_id: this.currentUser.customer_id,
      page: 1,
      per_page: this.perPage
    }
    this.getOrderHistory(data)
  },
  methods: {
    ...mapActions(['getOrderHistory']),
    ...mapMutations(['setCurrentOrder']),
    addressStr (address) {
      if (address) {
        const addressStr = []
        if (address.number) {
          addressStr.push(address.number)
        }
        if (address.street) {
          addressStr.push(address.street)
        }
        if (address.city) {
          addressStr.push(address.city)
        }
        if (address.postcode) {
          addressStr.push(address.postcode)
        }
        return address ? addressStr.join(', ') : ''
      }
      return ''
    },
    updateOrderHistory (page) {
      const data = {
        type: 'customer',
        customer_id: this.currentUser.customer_id,
        page,
        per_page: this.perPage
      }
      this.getOrderHistory(data)
    }
  }
}
